<template>
  <div class="sticky-container">
    <nav
      id="story-navigation"
      class="navbar navbar-story"
      role="navigation"
      ref="storynavigation"
      v-if="false"
      :class="{
        'is-sticky': isSticky,
        'has-breadcrumb': breadcrumbLinks.length > 0,
      }"
      :style="{ top: (isSticky ? heightToStickAt : 0) + 'px' }"
    >
      <div class="navbar-brand">
        <div class="navbar-item">
          360° Leistungsportfolio
        </div>
        <a
          role="button"
          class="navbar-burger burger"
          @click="expanded = !expanded"
          :class="{ 'is-active': expanded }"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div
        class="navbar-menu"
        :class="{ 'is-active': expanded }"
        v-if="contentNavigation"
      >
        <div
          class="navbar-item has-dropdown"
          :class="{
            'is-active': activeDropdowns[index],
            'is-current': `/${$route.params.id}` === navbarMenu.link,
          }"
          v-for="(navbarMenu, index) in contentNavigation"
          v-bind:key="index"
          @click="openDropdown(index)"
        >
          <template
            v-if="
              [
                viewports.DESKTOP.name,
                viewports.WIDESCREEN.name,
                viewports.FULL_HD.name,
              ].includes(currentViewport)
            "
          >
            <RouterLink class="navbar-link is-arrowless" :to="navbarMenu.link">
              <SvgIcon
                :icon="
                  'icon--navigation_' +
                    navbarMenu.title.toLowerCase().replace(' ', '-')
                "
                class="is-primary is-size-2 mr-4"
              ></SvgIcon>
              {{ navbarMenu.title }}
            </RouterLink>
          </template>
          <div v-else class="navbar-link is-arrowless">
            <SvgIcon
              :icon="'icon--navigation_' + navbarMenu.title.toLowerCase()"
              class="is-primary is-size-2 mr-3"
            ></SvgIcon>
            <div>
              {{ navbarMenu.title }}
            </div>
          </div>

          <div class="navbar-dropdown">
            <RouterLink
              class="navbar-item"
              v-for="(navbarItem, childIndex) in navbarMenu.children"
              :to="navbarItem.link"
              v-bind:key="childIndex"
            >
              {{ navbarItem.title }}
            </RouterLink>
          </div>
        </div>
      </div>

      <transition name="fade">
        <div class="story__controls" v-if="isSticky">
          <RouterLink
            class="control--previous"
            :to="storyPrevious.link"
            v-if="storyPrevious"
          >
            <img
              src="@/assets/img/chevron-left.svg"
              style="transform: rotate(180deg)"
            />
          </RouterLink>
          <RouterLink
            class="control--next"
            :to="storyNext.link"
            v-if="storyNext"
          >
            <img src="@/assets/img/chevron-right.svg" />
          </RouterLink>
        </div>
      </transition>
    </nav>
    <div
      class="sticky-container__placeholder"
      ref="placeholder"
      v-if="isSticky"
      :style="{ height: heroHeight + 'px' }"
    ></div>

    <div
      class="navbar navbar-story__secondary"
      role="navigation"
      v-if="breadcrumbLinks.length > 0"
    >
      <div class="navbar-menu" v-if="contentNavigation">
        <div
          class="navbar-item"
          v-for="(breadcrumbLink, index) in breadcrumbLinks"
          v-bind:key="'navbar_story_breadcrumb_' + index"
        >
          <RouterLink
            :to="breadcrumbLink.link"
            class="navbar-link is-arrowless"
            active-class="is-active"
          >
            {{ breadcrumbLink.title }}
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { viewports } from "../../store/constants/viewports";
import { orderProcess } from "../../store/constants/order-process";
import Vue from "vue";
import SvgIcon from "../svg/SvgIcon";

export default {
  name: "StoryNavigation",
  components: { SvgIcon },
  data() {
    return {
      isSticky: false,
      heroFooterHeight: 0,
      heroHeight: 0,
      scrollOffset: 0,
      expanded: false,
      activeDropdowns: [],
      viewports: viewports,
    };
  },
  props: ["contentData"],
  computed: {
    ...mapGetters(["cmsPage", "currentViewport", "currentOrderProcessStep"]),
    contentNavigation() {
      if (this.cmsPage.page) {
        return this.cmsPage.page.navigation.story;
      }
      return null;
    },
    flatContentNavigation() {
      let flatNavigation = [];
      if (this.cmsPage.page) {
        this.cmsPage.page.navigation.story.forEach((parentLink) => {
          flatNavigation = flatNavigation.concat(parentLink.children);
        });
      }

      return flatNavigation;
    },
    currentNavigationLinkIndex() {
      for (let i = 0; i < this.flatContentNavigation.length; i++) {
        if (this.flatContentNavigation[i].link === this.$route.path) {
          return i;
        }
      }
      return undefined;
    },
    storyPrevious() {
      if (this.currentNavigationLinkIndex < 1) {
        return null;
      } else {
        let i = this.currentNavigationLinkIndex - 1;
        return this.flatContentNavigation[i];
      }
    },
    storyNext() {
      if (
        this.currentNavigationLinkIndex >= this.flatContentNavigation.length
      ) {
        return null;
      } else {
        let i = this.currentNavigationLinkIndex + 1;
        return this.flatContentNavigation[i];
      }
    },
    breadcrumbLinks() {
      let breadcrumbLinks = [];
      let vm = this;

      if (this.contentNavigation) {
        this.contentNavigation.forEach((element) => {
          if (element.link === `/${vm.$route.params.id}`) {
            breadcrumbLinks = element.children;
          }
        });
      }
      return breadcrumbLinks;
    },

    heightToStickAt() {
      if (
        [
          orderProcess.STEPS.NO_ORDER_ONGOING,
          orderProcess.STEPS.ORDER_COMPLETED,
        ].includes(this.currentOrderProcessStep)
      ) {
        return this.headerHeight;
      } else {
        if (
          [
            viewports.WIDESCREEN.name,
            viewports.DESKTOP.name,
            viewports.FULL_HD.name,
          ].includes(this.currentViewport)
        ) {
          return 112;
        } else {
          return 56;
        }
      }
    },
    headerHeight() {
      if (
        [
          viewports.WIDESCREEN.name,
          viewports.DESKTOP.name,
          viewports.FULL_HD.name,
        ].includes(this.currentViewport)
      ) {
        return 183;
      } else {
        return 56;
      }
    },
  },
  methods: {
    openDropdown(index) {
      if (this.activeDropdowns[index]) {
        Vue.set(this.activeDropdowns, index, false);
      } else {
        this.activeDropdowns = [];
        for (let i = 0; i < this.contentNavigation.length; i++) {
          this.activeDropdowns[i] = false;
        }
        this.activeDropdowns[index] = true;
      }
    },
    evaluateStickyness() {
      let scrollPosition = window.pageYOffset;
      this.adjustHeights();
      this.isSticky =
        this.scrollOffset - scrollPosition <= this.heightToStickAt;
    },
    adjustHeights() {
      this.heroHeight = this.$refs.storynavigation.offsetHeight;
      if (this.$refs.placeholder) {
        this.scrollOffset = this.$refs.placeholder.offsetTop;
      } else {
        this.scrollOffset = this.$refs.storynavigation.offsetTop;
      }
    },
    attachEventListeners() {
      window.addEventListener("scroll", this.evaluateStickyness);
      window.removeEventListener("resize", this.adjustHeights);
    },
    removeEventListeners() {
      window.removeEventListener("scroll", this.evaluateStickyness);
      window.removeEventListener("resize", this.adjustHeights);
    },
  },
  mounted() {
    this.attachEventListeners();
    this.heroHeight = this.$refs.storynavigation.offsetHeight;
    this.scrollOffset = this.$refs.storynavigation.offsetTop;
    this.evaluateStickyness();
  },
  destroyed() {
    this.removeEventListeners();
  },
};
</script>
<style lang="scss" scoped>
.navbar-link {
  display: flex;
}
</style>
